module.exports = __webpack_public_path__ + "img/3.d0d2a91b.jpg";